import styles from "./clientTestimonials.module.css";
import { StarIcon } from "@/assets/svg";

type Testimonial = {
  name: string;
  rating: number;
  location: string;
  locationFlag: string; // Emoji flag or country code
  testimonial: string;
  avatar: string; // Placeholder for avatar image path
};

const testimonials: Testimonial[] = [
  {
    name: "Larry F",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial: "Thank you so much for saving us money on our property taxes every year.",
    avatar: "",
  },
  {
    name: "Rance",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "I am very satisfied with this company and would recommend it to everyone. They do what they say they will.",
    avatar: "",
  },
  {
    name: "Karl L",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "The company has saved me money on my protest and for that I am thankful. They are very informative about what they are doing for me. I recommend them to everyone.",
    avatar: "",
  },
  {
    name: "David S",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial: "Good job! Great Company!",
    avatar: "",
  },
  {
    name: "Paula",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "These guys are awesome. Helped me save money on my property taxes that were way too high. Very helpful.",
    avatar: "",
  },
  {
    name: "Christopher",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "I thank you for a job well done with the county and working to get the taxes down.",
    avatar: "",
  },
  {
    name: "Garza",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "These guys with this company know how to lower taxes. Going to use them every year. Thank you.",
    avatar: "",
  },
  {
    name: "Keith R",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "I recommend the company to everyone. They will do what they say and will go the extra mile to get the taxes lowered.",
    avatar: "",
  },
  {
    name: "Breanna",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "You guys are awesome. You saved me money again this year on my Property Tax and for that I am happy and grateful. Everyone needs this service to keep on top of their Property Taxes.",
    avatar: "",
  },
  {
    name: "D Hastings",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial: "A great group of people always do a good job.",
    avatar: "",
  },
  {
    name: "R Raymond",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial: "Thanks to you guys I don't have to worry about getting my property tax lowered.",
    avatar: "",
  },
  {
    name: "J M Burke",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "Thank you all for taking care of my account this year. You sure saved me some money.",
    avatar: "",
  },
  {
    name: "Danny",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial: "The company did a great job for me with my County Taxes. Thank you so much.",
    avatar: "",
  },
  {
    name: "Hillary",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "I was so excited when my results on my protest for my property taxes, I would recommend this company to everyone. They work and play.",
    avatar: "",
  },
  {
    name: "Stefanos",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial: "I am so glad your company helped me and got my Property Tax lowered!",
    avatar: "",
  },
  {
    name: "K Fryer",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial: 'All I can say is "thank you so much for a job well done".',
    avatar: "",
  },
  {
    name: "R Smith",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "I recommend everyone to try this company for their protest needs with the County Property Tax needs.",
    avatar: "",
  },
  {
    name: "Douglas M",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "This company helps me save on my property tax and works with the county so that I do not have to.",
    avatar: "",
  },
  {
    name: "C.L.",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "Thank you so much for protesting our taxes for us. We can keep working our business and not have to worry about a protest.",
    avatar: "",
  },
  {
    name: "T Barr",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial: "Thank you for helping us save money on our taxes with the county.",
    avatar: "",
  },
  {
    name: "Sylvia",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "Great company to work with and easy to understand. They get the jobe done. Happy with their services.",
    avatar: "",
  },
  {
    name: "Shirley H.",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "I am so happy I signed up for this service because this group has saved me money. They are a great group to work with.",
    avatar: "",
  },
  {
    name: "Jordan",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial:
      "I was not expecting the results I got from this company for protesting my property taxes. What a huge savings. I'm going to tell everyone I know to jump in. Thank you guys!",
    avatar: "",
  },
  {
    name: "R Peck",
    rating: 5.0,
    location: "United States",
    locationFlag: "US",
    testimonial: "Great job guys! Thank you for helping me this year and I will be back next year.",
    avatar: "",
  },
];

/**
 * ClientTestimonials Component
 * Displays client testimonials with ratings and locations
 */
export const ClientTestimonials = () => {
  // Duplicate testimonials for seamless infinite scroll
  const duplicatedTestimonials = [...testimonials, ...testimonials, ...testimonials];

  return (
    <section className={styles.testimonialsSection}>
      <div className={styles.testimonialsContent}>
        <h2 className={styles.heading}>
          What Clients Say About <span className={styles.andyHighlight}>Andy</span>
        </h2>

        <div className={styles.testimonialsWrapper}>
          <div className={styles.testimonialsScroll}>
            {duplicatedTestimonials.map((testimonial, index) => (
              <div key={index} className={styles.testimonialCard}>
                <div className={styles.cardHeader}>
                  <div className={styles.avatarWrapper}>
                    {testimonial.avatar ? (
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className={styles.avatar}
                      />
                    ) : (
                      <div className={styles.avatarPlaceholder}>{testimonial.name.charAt(0)}</div>
                    )}
                  </div>
                  <div className={styles.userInfo}>
                    <h3 className={styles.userName}>{testimonial.name}</h3>
                    <div className={styles.ratingContainer}>
                      <StarIcon className={styles.starIcon} />
                      <span className={styles.rating}>{testimonial.rating}</span>
                    </div>
                    <div className={styles.locationContainer}>
                      <span className={styles.flagIcon}>{testimonial.locationFlag}</span>
                      <span className={styles.location}>{testimonial.location}</span>
                    </div>
                  </div>
                </div>
                <p className={styles.testimonialText}>{testimonial.testimonial}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.quotationMark} aria-hidden="true">
        &quot;
      </div>
    </section>
  );
};
